import { Button, Heading, Text } from '@gassan-ui'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type MaintenanceBannerProps = {
  className?: string
}

const MaintenanceBanner: FC<MaintenanceBannerProps> = ({ className }) => {
  const { t } = useTranslation('maintenance')

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="mx-auto flex w-full max-w-[500px] flex-col items-center px-4 py-16 text-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full text-tabaccoBrown">
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3281 37.332C21.3281 37.332 25.3281 42.6654 31.9948 42.6654C38.6615 42.6654 42.6615 37.332 42.6615 37.332M39.9948 23.9987H40.0215M23.9948 23.9987H24.0215M58.6615 31.9987C58.6615 46.7262 46.7223 58.6654 31.9948 58.6654C17.2672 58.6654 5.32812 46.7262 5.32812 31.9987C5.32812 17.2711 17.2672 5.33203 31.9948 5.33203C46.7223 5.33203 58.6615 17.2711 58.6615 31.9987ZM41.3281 23.9987C41.3281 24.7351 40.7311 25.332 39.9948 25.332C39.2585 25.332 38.6615 24.7351 38.6615 23.9987C38.6615 23.2623 39.2585 22.6654 39.9948 22.6654C40.7311 22.6654 41.3281 23.2623 41.3281 23.9987ZM25.3281 23.9987C25.3281 24.7351 24.7312 25.332 23.9948 25.332C23.2584 25.332 22.6615 24.7351 22.6615 23.9987C22.6615 23.2623 23.2584 22.6654 23.9948 22.6654C24.7312 22.6654 25.3281 23.2623 25.3281 23.9987Z"
              stroke="#785D42"
              strokeWidth="5.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="flex flex-col items-center gap-4">
          <Heading
            variant="h3"
            as="h2"
            className="mb-0 whitespace-pre-line font-semibold leading-[120%]"
          >
            {t('title')}
          </Heading>
          <Text className="text-shade-700">{t('description')}</Text>

          <Text className="text-shade-700">{t('supportText')}</Text>

          <Button variant="dark" as="link" href={t('buttonUrl')}>
            {t('buttonDescription')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default MaintenanceBanner
